var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-popup absolute bg-white rounded py-2 px-2 inset-3",class:[_vm.width ? _vm.width : '']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }